module.exports = __webpack_public_path__ + "static/media/circles.ef58d6d7.svg";